import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SavedTestcaseFilter, UpsertSavedTestcaseFilterRequest } from '../models/saved-testcase-filter.model';

@Injectable({ providedIn: 'root' })
export class TestcaseLinkFilterService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/api/v1/projects`;

  list(projectId: string): Observable<SavedTestcaseFilter[]> {
    return this.http.get<SavedTestcaseFilter[]>(`${this.base}/${projectId}/me/testcase-link-filters`);
  }

  save(projectId: string, request: UpsertSavedTestcaseFilterRequest): Observable<SavedTestcaseFilter> {
    return this.http.post<SavedTestcaseFilter>(`${this.base}/${projectId}/me/testcase-link-filters`, request);
  }

  delete(projectId: string, name: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/${projectId}/me/testcase-link-filters/${encodeURIComponent(name)}`);
  }
}
